import { render, staticRenderFns } from "./ProductSortFilter.vue?vue&type=template&id=cffb1e74&scoped=true"
import script from "./ProductSortFilter.vue?vue&type=script&lang=js"
export * from "./ProductSortFilter.vue?vue&type=script&lang=js"
import style0 from "./ProductSortFilter.vue?vue&type=style&index=0&id=cffb1e74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffb1e74",
  null
  
)

export default component.exports